import React, { RefObject } from 'react'

import { SectionSubtitle } from '..'

import { PlayerDescription } from './styles'

const MPDescription = ({
  cleanedList,
  currentTrackIndex,
  audioRef,
}: {
  cleanedList: {
    title: string
    url: string
    routine: string
    logUID: string
    visibility: boolean
  }[]
  currentTrackIndex: number
  audioRef: RefObject<HTMLAudioElement>
}) => {
  const currentTrack =
    cleanedList.length > 0 && cleanedList[currentTrackIndex]
      ? cleanedList[currentTrackIndex]
      : null

  return (
    <PlayerDescription
      style={{
        alignItems: 'flex-start',
        alignSelf: 'flex-end',
        marginBottom: '10px',
        width: 'calc(100% - 155px)',
        padding: '0 20px 0 0',
      }}
    >
      <SectionSubtitle
        children={currentTrack ? currentTrack.title.replace('.mp3', '') : '---'}
        fontSize={14}
        fontWeight={600}
        lineHeight={14}
      />
      <p>By Diga-ah!</p>
      <audio ref={audioRef} src={currentTrack ? currentTrack.url : ''} />
    </PlayerDescription>
  )
}

export default MPDescription
